/**
 * @license
 * Copyright Endlessjs. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { NgModule } from '@angular/core';

import { ElSharedModule } from '../shared/shared.module';
import { ElOverlayModule } from '../cdk/overlay/overlay.module';
import { ElIconModule } from '../icon/icon.module';
import { ElButtonModule } from '../button/button.module';

import { ElSearchComponent, ElSearchFieldComponent } from './search.component';
import { ElSearchService } from './search.service';


@NgModule({
  imports: [
    ElSharedModule,
    ElOverlayModule,
    ElIconModule,
    ElButtonModule,
  ],
  declarations: [
    ElSearchComponent,
    ElSearchFieldComponent,
  ],
  exports: [
    ElSearchComponent,
    ElSearchFieldComponent,
  ],
  providers: [
    ElSearchService,
  ],
  entryComponents: [
    ElSearchFieldComponent,
  ],
})
export class ElSearchModule {
}
